import type { ThemeRow, ThemeTokens } from "@agape/shared";

const MIN_REQUIRED_GLOWS = 3;

const isStringArray = (arr: unknown): arr is string[] =>
  Array.isArray(arr) && arr.every((item) => typeof item === "string");

const parseGlowColors = (raw: string | null | undefined): string[] | null => {
  if (!raw) {
    return null;
  }
  try {
    const parsed: unknown = JSON.parse(raw);
    if (isStringArray(parsed) && parsed.length > 0) {
      return parsed;
    }
  } catch {
    // Ignore parsing errors for invalid raw JSON strings, falling back safely to null
  }
  return null;
};

/**
 * Atmospheric background orbs: active theme orbs if defined, otherwise
 * resolved tokens, and as last resort brand CSS variables.
 */
export const getGlowColors = (globalTheme: ThemeRow | null, globalToks: ThemeTokens | null) => {
  if (globalTheme) {
    const glowArray = parseGlowColors(globalTheme.glow_colors);
    if (glowArray && glowArray.length >= MIN_REQUIRED_GLOWS) {
      return {
        glow0: glowArray[0],
        glow1: glowArray[1],
        glow2: glowArray[2],
      };
    }
  }

  if (globalToks && globalToks.id !== "none") {
    return {
      glow0: globalToks.glow0,
      glow1: globalToks.glow1,
      glow2: globalToks.glow2,
    };
  }

  return { glow0: "var(--glow-0)", glow1: "var(--glow-1)", glow2: "var(--glow-2)" };
};
